function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 4,
  width: 14,
  height: 10,
  rx: 1
}));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 4,
  width: 14,
  height: 10,
  rx: 1,
  stroke: "currentColor",
  strokeWidth: 3,
  mask: "url(#path-1-inside-1)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 14V16H6H14",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/dashboard.ce4b7ea9.svg";
export { SvgComponent as ReactComponent };